import { useCurrentLocale } from "@/context/LanguageContext";

export const useIsArcade = () => {
    const locale = useCurrentLocale();
    return locale === "en-US";
};
